import React from "react";
import "./Alert.scss";
import Button from "../Button";
interface AlertProps {
  title: string;
  message: string;
  showOkButton?: boolean;
  showCancelButton?: boolean;
  okButtonText?: string;
  cancelButtonText?: string;
  onOk?: () => void;
  onCancel?: () => void;
}

const Alert = (props: AlertProps) => {
  const {
    title,
    message,
    showOkButton = true,
    showCancelButton = true,
    okButtonText = "OK",
    cancelButtonText = "Cancel",
    onOk,
    onCancel,
  } = props;

  return (
    <div className="alert-container">
      <div className="alert-content">
        <h2 className="mb-2">{title}</h2>
        <p className="text-gray-600 ">{message}</p>
        <div className="button-container flex justify-center align-items-center">
          {showCancelButton && (
            <Button text={cancelButtonText} onClick={onCancel} shape="chamfer" size="md" type="grey"></Button>
          )}
          {showOkButton && (
            <Button text={okButtonText} onClick={onOk} shape="chamfer" size="md"></Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Alert;
